// WOW Animations
export function wowAnimations() {
  const wow = new WOW (
    {
      boxClass: 'wow', // default
      animateClass: 'animate__animated',
      offset: 150,
    }
  )
  wow.init();
}